/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2022-10-08 15:32:08
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-10-25 14:40:31
 * @FilePath: \xm-runing-main\src\router\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type {RouteRecordRaw} from 'vue-router';
import type {App} from 'vue';
import {createRouter, createWebHistory} from 'vue-router';
import {basicRoutes} from './routes';

// app router
// 创建一个可以被 Vue 应用程序使用的路由实例
export const router = createRouter({
  // 创建一个 hash 历史记录。
  history: createWebHistory(''),
  // 应该添加到路由的初始路由列表。
  routes: basicRoutes as unknown as RouteRecordRaw[],
  // 是否应该禁止尾部斜杠。默认为假
  strict: true,
  scrollBehavior: () => ({left: 0, top: 0}),
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.currentRoute.value.fullPath

  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

function checkErrorPath ( path ) {
  if ( path.lastIndexOf( '/app/' ) != 0 ) {
    console.log( "ERROR" )
    return path.substring( path.lastIndexOf( '/app/' ), path.length )
  }
  return path
}
//判断错误路由
function isErrorPath ( path ) {
  return path.lastIndexOf( '/app/' ) != 0
}

const JIE_SERIES_DASHBOARD_PATH = '/jieSeriesDashboard';

function openJieSeriesDashboardInNewTab(to: { fullPath: string }) {
  window.open(window.location.origin + to.fullPath, '_blank');
}

// 基座应用路由守卫
router.beforeEach( ( to, from, next ) => {
  if (
    to.path === JIE_SERIES_DASHBOARD_PATH &&
    from.matched.length > 0 &&
    from.path !== JIE_SERIES_DASHBOARD_PATH
  ) {
    openJieSeriesDashboardInNewTab(to);
    return next(false);
  }

  // 系统授权到期校验统一以后端为准（loadSystem 中的 loadSystemDateVaildate 读取
  // /api/go-lcc/gateway/expireTime）。此处不再使用 xmgoing-utils 内置的
  // GoingNewUtils.timeOut —— 该值为编译期硬编码常量，会与实际授权日期脱节，
  // 导致授权未到期也被判定为过期（2026-11-01 线上事故）。

  //历史记录完善
  const fullPath = to.fullPath
  history.replaceState( { back: from.path }, to.name, isErrorPath( fullPath ) ? checkErrorPath( fullPath ) : '' )
  if ( !window.history.state.current ) window.history.state.current = to.fullPath
  if ( !window.history.state.back ) window.history.state.back = from.fullPath


  next()
} )

// config router
// 配置路由器
export function setupRouter(app: App<Element>) {
  app.use(router);
  app.$router = router;
}

export default router
